export function convertSlugToUrl(slug, parameters) {
    let url = slug;
    Object.entries(parameters).forEach(([key, value]) => url = url.replace(`:${key}`, value));
    return url;
}

export const currency = function (number) {
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(number);
};

export const convertStatusArticulo = function (status) {
    if (!status) return status;

    const map = {
        "ACTIVO": "A",
        "INACTIVO": "I",
        "PAUSADO": "P",
        "ARCHIVADO": "a",
        "BORRADOR": "B",
        "A": "ACTIVO",
        "C": "INACTIVO",
        "I": "INACTIVO",
        "P": "PAUSADO",
        "a": "ARCHIVADO",
        "B": "BORRADOR"
    };
    const key = map[status] ? status.toUpperCase() : status;
    return map[key] || status;

};

export const rfcValido = function (rfc, aceptarGenerico = true) {
    const re = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
    var validado = rfc.match(re);
    if (!validado)  return false; //Coincide con el formato general del regex?
        
    //Separar el dígito verificador del resto del RFC
    const digitoVerificador = validado.pop(),
        rfcSinDigito = validado.slice(1).join(''),
        len = rfcSinDigito.length,
        //Obtener el digito esperado
        diccionario = "0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ",
        indice = len + 1;
    var suma, digitoEsperado;
    if (len === 12) suma = 0
    else suma = 481; //Ajuste para persona moral

    for (var i = 0; i < len; i++) suma += diccionario.indexOf(rfcSinDigito.charAt(i)) * (indice - i);

    digitoEsperado = 11 - suma % 11;
    if (digitoEsperado === 11) digitoEsperado = 0;
    else if (digitoEsperado === 10) digitoEsperado = "A";

    //El dígito verificador coincide con el esperado?
    // o es un RFC Genérico (ventas a público general)?
    if ((String(digitoVerificador) !== String(digitoEsperado)) && (!aceptarGenerico || (rfcSinDigito + String(digitoVerificador)) !== "XAXX010101000")) return false;
    else if (!aceptarGenerico && (rfcSinDigito + String(digitoVerificador)) === "XEXX010101000") return false;

    return (rfcSinDigito + String(digitoVerificador));
};